import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import otherQuiz from "../../../template/images/other-quiz-img.png";
import otherQuizpersonal from "../../../template/images/other-quiz-personal.png";
import otherQuizstock from "../../../template/images/other-quiz-stock.png";
import Loader from "../../layout/lodaer";
import otherQuizp1 from "../../../template/images/other-quiz-personal-1.png";
import otherQuizp2 from "../../../template/images/other-quiz-personal-2.png";
import otherQuizmaster from "../../../template/images/other-quiz-master-taxes.png";
import defenceQuiz from "../../../template/images/defence-quiz.png";
import banner from "../../../template/images/quiz-banners.png";

function OtherQuizes() {
  const navigate = useNavigate();

  const handleStartQuiz = (id, topic) => {
    navigate(`/quiz/${id}/${topic}`);
  };
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      {!loading ? (
        <>
          <div className="row bannerQuiz">
              <img src={banner} alt="banner-quiz" />
          </div>
          <div className="other-quizes-section">
            <h2>Check other quizzes</h2>
            <div className="other-quiz-list-container">
            <div className="row">
                <div className="col-1 col-md-1"></div>
                <div className="col-12 col-md-3">
                  <img src={defenceQuiz} alt="" className="quiz-img" />
                </div>
                <div className="col-12 col-md-6 other-quiz-content">
                  <span className="quiz-name">Defend Your Digital Space!</span>
                  <p className="quiz-desc">
                    Stay ahead of digital threats with our ‘Digital Defence’
                    quiz! Test your knowledge on fraud trends and learn how to
                    protect your online rights.
                  </p>
                  
                  <button
                    className="start-quiz"
                    onClick={() => handleStartQuiz(38, "DigitalDefense")}
                  >
                    Start Quiz
                  </button>
                </div>
              </div>
       
              <div className="row">
                <div className="col-1 col-md-1"></div>
                <div className="col-12 col-md-3">
                  <img src={otherQuiz} alt="" className="quiz-img" />
                </div>
                <div className="col-12 col-md-6 other-quiz-content">
                  <span className="quiz-name">Mutual Fund Quiz</span>
                  <p className="quiz-desc">
                    Take the 'Mutual Fun Quiz' to explore the world of mutual
                    funds! Whether you're a beginner or an expert, test your
                    knowledge and learn more about this popular investment
                    option.
                  </p>
                  <button
                    className="start-quiz"
                    onClick={() => handleStartQuiz(33, "MutualFund")}
                  >
                    Start Quiz
                  </button>
                </div>
              </div>

              <div className="row d-none">
                <div className="col-1 col-md-1"></div>
                <div className="col-12 col-md-3">
                  <img src={otherQuizstock} alt="" className="quiz-img" />
                </div>
                <div className="col-12 col-md-6 other-quiz-content">
                  <span className="quiz-name">Stock Market Quiz</span>
                  <p className="quiz-desc">
                    Test your understanding of mutual fund fundamentals.
                  </p>
                  <button
                    className="start-quiz"
                    onClick={() => handleStartQuiz(23, "Stock Market")}
                  >
                    Start Quiz
                  </button>
                </div>
              </div>

              <div className="row d-none">
                <div className="col-1 col-md-1"></div>
                <div className="col-12 col-md-3">
                  <img src={otherQuizpersonal} alt="" className="quiz-img" />
                </div>
                <div className="col-12 col-md-6 other-quiz-content">
                  <span className="quiz-name">Personal Quiz</span>
                  <p className="quiz-desc">
                    Test your understanding of mutual fund fundamentals.
                  </p>
                  <button
                    className="start-quiz"
                    onClick={() => handleStartQuiz(24, "Personal Finance")}
                  >
                    Start Quiz
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-1 col-md-1"></div>
                <div className="col-12 col-md-3">
                  <img src={otherQuizp1} alt="" className="quiz-img" />
                </div>
                <div className="col-12 col-md-6 other-quiz-content">
                  <span className="quiz-name">Personal Finance Quiz 1</span>
                  <p className="quiz-desc">
                    Test your financial knowledge and sharpen your money
                    management skills with our quick quiz. Perfect for beginners
                    and those looking to refresh their personal finance basics!
                  </p>
                  <button
                    className="start-quiz"
                    onClick={() => handleStartQuiz(35, "personalFinanceQ1")}
                  >
                    Start Quiz
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-1 col-md-1"></div>
                <div className="col-12 col-md-3">
                  <img src={otherQuizp2} alt="" className="quiz-img" />
                </div>
                <div className="col-12 col-md-6 other-quiz-content">
                  <span className="quiz-name">Personal Finance Quiz 2</span>
                  <p className="quiz-desc">
                    Elevate your financial game with our Personal Finance Quiz.
                    Challenge your knowledge and master the basics of money
                    management, whether you're a beginner or looking to refine
                    your skills.
                  </p>
                  <button
                    className="start-quiz"
                    onClick={() => handleStartQuiz(36, "personalFinanceQ2")}
                  >
                    Start Quiz
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-1 col-md-1"></div>
                <div className="col-12 col-md-3">
                  <img src={otherQuizmaster} alt="" className="quiz-img" />
                </div>
                <div className="col-12 col-md-6 other-quiz-content">
                  <span className="quiz-name">Master Your Taxes quiz</span>
                  <p className="quiz-desc">
                    Are you ready to become a tax-savvy citizen? Take the quiz
                    and find out how much you know about Indian income tax!
                  </p>
                  <button
                    className="start-quiz"
                    onClick={() => handleStartQuiz(37, "taxmaster")}
                  >
                    Start Quiz
                  </button>
                </div>
              </div>
            </div>
          </div>{" "}
        </>
      ) : (
        <Loader />
      )}{" "}
    </>
  );
}

export default OtherQuizes;
